import React, { createContext, useContext, ReactNode } from 'react';
import { useFacebookPixel } from '@/hooks/useFacebookPixel';

interface FacebookPixelContextType {
  trackEvent: (eventName: string, parameters?: Record<string, any>) => void;
  trackPageView: () => void;
  trackPurchase: (value: number, currency?: string) => void;
  trackAddToCart: (contentName: string, value?: number) => void;
  trackLead: (contentName?: string) => void;
  trackCompleteRegistration: () => void;
  trackSubscribe: (value?: number) => void;
  trackMenuView: (menuName: string, restaurantName: string) => void;
  trackMenuItemView: (itemName: string, category: string, price?: number) => void;
  trackQRScan: (restaurantName: string) => void;
}

const FacebookPixelContext = createContext<FacebookPixelContextType | undefined>(undefined);

interface FacebookPixelProviderProps {
  children: ReactNode;
  pixelId?: string;
}

export const FacebookPixelProvider: React.FC<FacebookPixelProviderProps> = ({ 
  children, 
  pixelId = '1853428885267252' 
}) => {
  const facebookPixel = useFacebookPixel(pixelId);

  return (
    <FacebookPixelContext.Provider value={facebookPixel}>
      {children}
    </FacebookPixelContext.Provider>
  );
};

export const useFacebookPixelContext = () => {
  const context = useContext(FacebookPixelContext);
  if (context === undefined) {
    throw new Error('useFacebookPixelContext must be used within a FacebookPixelProvider');
  }
  return context;
};